(function () {
    angular
        .module("BuscaAtivaEscolar")
        .directive("metricsCountry", function (moment, Platform, Reports, Charts, ngToast) {
            function init(scope, element, attrs) {
                scope.availableOptions = [
                    { id: 1, name: "Status atual" },
                    { id: 2, name: "Status em 31/12/2024" },
                    { id: 3, name: "Status em 31/12/2020" },
                    { id: 4, name: "Status em 31/12/2019" },
                    { id: 5, name: "Status em 31/12/2018" },
                    { id: 6, name: "Status em 31/12/2017" },
                ];
                scope.selectedOption = {
                    id: 1,
                    name: "Status atual",
                };

                scope.stats = {};

                scope.status_2024 = {
                    num_tenants: 3482, // Municipios configurados
                    num_ufs: 21, // Adesoes estaduais realizadas
                    num_signups: 3493, // Adesoes realizadas
                    num_pending_setup: 11, // Em configuracao
                    num_alerts: 554142,  // Alertas Aprovados
                    num_pending_alerts: 148292, // Alertas pendentes
                    num_rejected_alerts: 402949, // Alertas rejeitados
                    num_total_alerts: 1105383,  // total de alertas
                    num_cases_in_progress: 0, // Nao sao usados
                    num_children_reinserted: 0, // Nao sao usados
                    num_pending_signups: 3, // Adesoes munucipais pendestes
                    num_pending_state_signups: 0, // Adesoes estados pendestes
                    num_children_in_school: 119342,  // Soma rematriculas // Soma Casos Total // Casos concluidos
                    num_children_in_observation: 180475, // Soma rematriculas // Soma Casos Total // Casos em andamento Dentro da Escola
                    num_children_out_of_school: 81809, // Soma Casos Total // Casos em andamento fora da Escola
                    num_children_cancelled: 162929, // Soma Casos Total // Casos cancelados 
                    num_children_transferred: 5994, // Soma Casos Total // Casos Tranferidos
                    num_children_interrupted: 3595, // Soma Casos Total // Casos Interrompidos
                };

                scope.status_2020 = {
                    num_tenants: 2518,
                    num_ufs: 21,
                    num_signups: 3214,
                    num_pending_setup: 695,
                    num_alerts: 160719,
                    num_pending_alerts: 110836,
                    num_rejected_alerts: 79865,
                    num_total_alerts: 351420,
                    num_cases_in_progress: 121644,
                    num_children_reinserted: 79595,
                    num_pending_signups: 1,
                    num_pending_state_signups: 1,
                    num_children_in_school: 6050,
                    num_children_in_observation: 73545,
                    num_children_out_of_school: 48060,
                    num_children_cancelled: 32299,
                    num_children_transferred: 188,
                    num_children_interrupted: 577,
                };

                scope.status_2019 = {
                    num_tenants: 2518,
                    num_ufs: 21,
                    num_signups: 3214,
                    num_pending_setup: 695,
                    num_alerts: 55106,
                    num_pending_alerts: 88518,
                    num_rejected_alerts: 42081,
                    num_total_alerts: 185705,
                    num_cases_in_progress: 121644,
                    num_children_reinserted: 79595,
                    num_pending_signups: 1,
                    num_pending_state_signups: 1,
                    num_children_in_school: 307,
                    num_children_in_observation: 16800,
                    num_children_out_of_school: 26040,
                    num_children_cancelled: 11959,
                    num_children_transferred: 0,
                    num_children_interrupted: 0,
                };
                scope.status_2018 = {
                    num_tenants: 2518,
                    num_ufs: 21,
                    num_signups: 3214,
                    num_pending_setup: 695,
                    num_alerts: 5776,
                    num_pending_alerts: 24866,
                    num_rejected_alerts: 11663,
                    num_total_alerts: 42305,
                    num_cases_in_progress: 121644,
                    num_children_reinserted: 79595,
                    num_pending_signups: 1,
                    num_pending_state_signups: 1,
                    num_children_in_school: 143,
                    num_children_in_observation: 316,
                    num_children_out_of_school: 4655,
                    num_children_cancelled: 662,
                    num_children_transferred: 0,
                    num_children_interrupted: 0,
                };

                scope.status_2017 = {
                    num_tenants: 2518,
                    num_ufs: 21,
                    num_signups: 3214,
                    num_pending_setup: 695,
                    num_alerts: 114,
                    num_pending_alerts: 149,
                    num_rejected_alerts: 10,
                    num_total_alerts: 273,
                    num_cases_in_progress: 121644,
                    num_children_reinserted: 79595,
                    num_pending_signups: 1,
                    num_pending_state_signups: 1,
                    num_children_in_school: 2,
                    num_children_in_observation: 1,
                    num_children_out_of_school: 102,
                    num_children_cancelled: 9,
                    num_children_transferred: 0,
                    num_children_interrupted: 0,
                };

                function refreshMetrics() {
                    return Reports.getCountryStats(function (data) {
                        if (data.status !== "ok") {
                            ngToast.danger(
                                "Ocorreu um erro ao carregar os números gerais da plataforma"
                            );
                            return;
                        }

                        scope.stats = data.stats;
                    });
                }

                Platform.whenReady(function () {
                    refreshMetrics();
                });
            }

            return {
                link: init,
                replace: true,
                templateUrl: "/views/components/metrics_country.html",
            };
        });
})();